import { Component } from '@angular/core';

@Component({
  selector: 'app-logs-user-log',
  templateUrl: './logs-user-log.component.html',
  styleUrls: ['./logs-user-log.component.scss'],
})
export class LogsUserLogComponent {}
